
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import { Articulo } from '@/__env/lib/Articulos';
    import detalles from './articulos-detalles.vue';
    import lista from './articulos-lista.vue';
    import mini from './articulos-lista-mini.vue';
    import inicio from './articulos-lista-inicio.vue';
    import { timingSafeEqual } from 'crypto';
    import { Utiles } from '@/__env/pluggins/event-bus';




    @Component( {
        name: "Componente",
        props: {},
        components: {
            detalles,
            lista,
            mini,
            inicio,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public ExpandirDetalles: boolean = false;
        public Estado: 'cargando' | 'ok' | 'vacio' = 'ok';
        public Focused: boolean = false;
        public InputError: boolean = false;
        public InputErrorTimer: boolean = false;
        async onInputError()
        {
            this.InputError = true;
            this.Busqueda = '';
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            await Wait( 200 );
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            await Wait( 200 );
            this.InputErrorTimer = true;
            await Wait( 200 );
            this.InputErrorTimer = false;
            this.InputError = false;

        }

        public BuscarEnTodaLaDescripcion: boolean = false;
        @Watch( 'BuscarEnTodaLaDescripcion' )
        onBuscarEnTodaLaDescripcion()
        {
            if ( this.Expandir )
                this.Buscar();
            document.getElementById( 'barra-izquierda-input' ).focus();
        }

        public AgregarDirectamente: boolean = false;
        @Watch( 'AgregarDirectamente' )
        onAgregarDirectamente()
        {
            console.log( 'eaea', this.AgregarDirectamente );
            document.getElementById( 'barra-izquierda-input' ).focus();
        }

        public BarraDerechaPrevio: string = '';
        protected expandir: boolean = false;
        public get Expandir() { return this.expandir; }
        public set Expandir( x: boolean )
        {
            this.expandir = x;
            if ( this.expandir )
            {
                this.Seleccionado = -1;
                this.Items.clear();
                if ( this.Busqueda )
                {
                    this.Buscar();
                }
                this.BarraDerechaPrevio = this.Controlador.Vista.BarraDerecha.Modo;
                this.Controlador.Vista.BarraDerecha.Modo = '';
                this.Controlador.Vista.BarraIzquierda.Estado = 'buscador';
                this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = '600px !important';
            } else
            {
                this.Controlador.Vista.BarraDerecha.Modo = this.BarraDerechaPrevio;
                this.Controlador.Vista.BarraIzquierda.Estado = '';
                this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = '0px !important';
                this.Seleccionado = -1;
                this.Busqueda = '';
                this.Items.clear();
                //this.Controlador.Vista.BarraIzquierda.Altura.Espacio = 'var(--toolbar-principal-height) !important';
            }
        }
        public Items: Articulo[] = [];
        public get Articulo()
        {
            if ( this.Items[this.Seleccionado] )
            {
                return this.Items[this.Seleccionado];
            }
        }
        public Seleccionado: number = -1;
        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        async onBusqueda()
        {
            let bb = this.Busqueda;

            if ( this.Expandir )
            {
                await Wait( 600 );
            }
            else
            {
                this.Items.clear();
                await Wait( 800 );
            }

            if ( bb == this.Busqueda )
            {
                await this.Buscar();
                this.Seleccionado = -1;

            }
        }

        public async Buscar( forzar?: boolean )
        {
            if ( !this.Busqueda )
            {
                this.Items.clear();
                return;
            } else
            {

                let ff: any = {};

                if ( this.Controlador.Configuracion.Opciones.BuscadorArticulos.OcultarFueraDeLista )
                {
                    ff.fuera_de_lista = 'N';
                }

                if ( this.Controlador.Configuracion.Opciones.BuscadorArticulos.OcultarDesactivados )
                {
                    ff.desactivado = 'N';
                }

                if ( !this.Expandir )
                {
                    ff.limit = 5;
                    ff.q = this.Busqueda;
                } else
                {
                    if ( this.BuscarEnTodaLaDescripcion )
                    {
                        ff.q1 = this.Busqueda;
                    } else
                    {
                        ff.q = this.Busqueda;
                    }
                }
                ff.details = 'imagenes,precio';
                ff.opciones_precio = {
                    tipo: this.Controlador.EdicionPedido.Tipo.Lista,
                    cliente: this.Controlador.EdicionPedido.Cliente.Id
                };

                this.Estado = 'cargando';
                let e = await Articulo.find( ff );
                if ( !e.Error )
                {
                    this.Items = e.Items;
                } else
                {
                    this.Items.clear();
                }

                if ( this.Items.hasRows() )
                    this.Estado = 'ok';
                else
                    this.Estado = 'vacio';
            }
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = '400px';
            this.BuscarEnTodaLaDescripcion = this.Controlador.Configuracion.Opciones.BuscadorArticulos.BusquedaExtendida;
            this.AgregarDirectamente = this.Controlador.Configuracion.Opciones.BuscadorArticulos.AgregaDirectamente;
        }

        KeyDown( e: KeyboardEvent )
        {
            if ( ['Escape', 'Enter', 'F3', 'PageUp', 'PageDown', 'ArrowDown', 'ArrowUp'].includes( e.key ) )
            {
                e.preventDefault();
            }
        }
        async KeyUp( e: KeyboardEvent )
        {

            if ( e.key == 'Escape' )
            {
                if ( this.Expandir )
                {
                    if ( this.ExpandirDetalles )
                    {
                        this.ExpandirDetalles = false;
                    }
                    else if ( this.Busqueda )
                    {
                        this.Busqueda = '';
                    } else
                    {
                        this.Items.clear();
                        this.Expandir = false;
                        this.ExpandirDetalles = false;
                    }
                }
                else
                {

                    if ( this.Items.hasRows() )
                    {
                        this.Items.clear();
                    } else
                    {
                        this.Busqueda = '';
                    }
                }
            }
            else if ( e.key == 'F3' )
            {
                this.Expandir = !this.Expandir;
            }
            else if ( e.key == 'PageUp' )
            {
                this.SeleccionarLista( 0 );
            }
            else if ( e.key == 'PageDown' )
            {
                this.SeleccionarLista( this.Items.length - 1 );
            }
            else if ( e.key == 'ArrowUp' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado - 1 );
            }
            else if ( e.key == 'ArrowDown' )
            {
                e.preventDefault();
                this.SeleccionarLista( this.Seleccionado + 1 );
            }
            else if ( e.key == 'ArrowLeft' && e.ctrlKey )
            {
                if ( this.Articulo && this.Expandir )
                {
                    if ( this.ExpandirDetalles && !this.$refs.articulosDetalles.esMinimo() )
                    {
                        this.$refs.articulosDetalles.Atras();
                    } else
                    {
                        this.ExpandirDetalles = false;
                    }

                }

                //this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = '400px';
            }
            else if ( e.key == 'ArrowRight' && e.ctrlKey )
            {
                if ( this.Articulo && this.Expandir )
                {
                    if ( this.ExpandirDetalles && !this.$refs.articulosDetalles.esMaximo() )
                    {
                        this.$refs.articulosDetalles.Siguiente();
                    } else
                    {
                        this.ExpandirDetalles = true;
                    }

                }

            }
            else if ( e.key == 'Enter' )
            {
                if ( this.Expandir )
                {
                    if ( this.Articulo )
                    {
                        console.log( 'ee', this.AgregarDirectamente );
                        this.Seleccionar( this.Articulo, this.AgregarDirectamente );
                    }
                }
                else if ( this.Items.hasRows() )
                {
                    if ( this.Articulo )
                    {
                        this.Seleccionar( this.Articulo );
                    } else if ( this.Busqueda && this.Busqueda.borraLetras().length > 1 )
                    {

                        if ( ! await this.Seleccionar( this.Busqueda ) )
                        {
                            this.onInputError();
                        }
                    }
                } else if ( this.Busqueda && this.Busqueda.borraLetras().length > 1 )
                {
                    if ( !await this.Seleccionar( this.Busqueda ) )
                    {
                        this.onInputError();
                    }
                }


            }


        }

        public SeleccionarLista( x: number )
        {
            if ( this.Items[x] )
            {
                this.Seleccionado = x;
                if ( this.Expandir )
                {
                    if ( !this.isVisibleLista( this.Seleccionado ) )
                        this.ScrollToItemLista();
                } else
                {
                    if ( !this.isVisibleListaMini( this.Seleccionado ) )
                        this.ScrollToItemListaMini();
                }

            }
        }

        protected ScrollToItemLista()
        {
            let element = document.getElementById( 'barra-izquierda-lista' );
            let element2 = document.getElementById( 'barra-izquierda-lista-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 20,
                duration: 0,
            } );
        }

        protected isVisibleLista( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista' );
            let winTop = lista.scrollTop();
            let winBottom = winTop + lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            return ( ( elBottom <= winBottom ) && ( elTop >= winTop ) );
        }

        protected ScrollToItemListaMini()
        {
            let element = document.getElementById( 'barra-izquierda-lista-mini' );
            let element2 = document.getElementById( 'barra-izquierda-lista-mini-item-' + this.Seleccionado );
            this.$vuetify.goTo( element2, {

                container: element,
                offset: 20,
                duration: 0,
            } );
        }

        protected isVisibleListaMini( item: number )
        {
            let el = JQuery( '#barra-izquierda-lista-mini-item-' + item );
            let lista = JQuery( '#barra-izquierda-lista-mini' );
            let winTop = lista.scrollTop();
            let winBottom = winTop + lista.height();
            let elTop = el.offset().top;
            let elBottom = elTop + el.height();
            return ( ( elBottom <= winBottom ) && ( elTop >= winTop ) );
        }

        async Seleccionar( x: string | Articulo, directamente?: boolean )
        {
            if ( !this.Controlador.EdicionPedido.Iniciado )
            {
                Utiles.Notificaciones.Error( '¡No hay un pedido seleccionado!' );
                return;
            }

            if ( directamente && x instanceof Articulo )
            {
                let e = await this.Controlador.EdicionPedido.NuevoItem.Agregar( x, x.CantidadFraccion );
                if ( e.Resultado )
                {
                    return true;
                } else
                {
                    if ( e.Mensaje )
                        Utiles.Notificaciones.Error( e.Mensaje );
                }
            }
            else
            {
                let e = await this.Controlador.EdicionPedido.NuevoItem.AgregarArticulo( x );
                if ( e.Resultado )
                {
                    this.Expandir = false;
                    await Wait( 10 );
                    this.Controlador.Vista.BarraIzquierda.Modo = 'cantidad';
                    return true;
                } else
                {
                    if ( e.Mensaje )
                        Utiles.Notificaciones.Error( e.Mensaje );
                }
            }

            return false;

        }
        AbrirMenu()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
        }
    }
